{
  "name": "@bda/web",
  "version": "1.0.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "pnpm uno:build && ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "dev": "pnpm uno:dev & ionic serve",
    "uno:dev": "unocss --watch",
    "uno:build": "unocss",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org level51 --project bda-web ./www/browser && sentry-cli sourcemaps upload --org level51 --project bda-web ./www/browser",
    "generate:assets": "pnpm capacitor-assets generate --pwa"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.5",
    "@angular/common": "^19.0.5",
    "@angular/compiler": "^19.0.5",
    "@angular/core": "^19.0.5",
    "@angular/forms": "^19.0.5",
    "@angular/platform-browser": "^19.0.5",
    "@angular/platform-browser-dynamic": "^19.0.5",
    "@angular/router": "^19.0.5",
    "@angular/service-worker": "^19.0.5",
    "@bda/lib": "workspace:*",
    "@capacitor/app": "^7.0.1",
    "@capacitor/core": "^7.2.0",
    "@capacitor/haptics": "^7.0.1",
    "@capacitor/keyboard": "^7.0.1",
    "@capacitor/status-bar": "^7.0.1",
    "@ionic/angular": "^8.4.1",
    "@sentry/angular": "^8.51.0",
    "canvas-confetti": "^1.9.3",
    "ionicons": "^7.2.1",
    "ngxtension": "^4.2.0",
    "pocketbase": "^0.25.2",
    "rxjs": "~7.8.0",
    "swiper": "^11.1.15",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.6",
    "@angular-eslint/builder": "^19.0.2",
    "@angular-eslint/eslint-plugin": "^19.0.2",
    "@angular-eslint/eslint-plugin-template": "^19.0.2",
    "@angular-eslint/schematics": "^19.0.2",
    "@angular-eslint/template-parser": "^19.0.2",
    "@angular/cli": "^19.0.6",
    "@angular/compiler-cli": "^19.0.5",
    "@angular/language-service": "^19.0.5",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^7.2.0",
    "@ionic/angular-toolkit": "^12.1.1",
    "@ionic/cli": "^7.2.0",
    "@sentry/cli": "^2.41.1",
    "@types/canvas-confetti": "^1.9.0",
    "@typescript-eslint/eslint-plugin": "^8.18.1",
    "@typescript-eslint/parser": "^8.18.1",
    "@typescript-eslint/types": "^8.18.1",
    "@typescript-eslint/utils": "^8.18.1",
    "@unocss/cli": "^0.65.1",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^48.11.0",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "typescript": "~5.6.3",
    "unocss": "^0.65.1"
  }
}
